// Endereços do admin usados em links entre páginas. O registro de seções
// (adminSections.tsx) usa os mesmos segmentos para montar as rotas.
export const CLINICAS_SEGMENT = "clinicas-assinantes";
export const CLINICAS_PATH = `/admin/${CLINICAS_SEGMENT}`;
export const clinicaPath = (id: number | string) => `${CLINICAS_PATH}/${id}`;
